import de from "../../assets/landing/de.svg";
// import gb from "../../assets/landing/English.svg";
import gb from "../../assets/landing/gb.svg";
import { useLanguage } from "../../contexts/LanguageContext";

const LanguageToggle = () => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <button
      type="button"
      onClick={toggleLanguage}
      aria-label={`Switch language (current: ${language.toUpperCase()})`}
      className="
        flex items-center justify-center cursor-pointer
        bg-[#000101] font-public-sans  font-medium rounded-[100px] relative z-10 gap-2  transition-all duration-300 
        w-[70px] h-[36px] sm:w-[90px] sm:h-[42px] md:w-[104px] md:h-[47px] 
         border-2 border-transparent bg-gradient-to-b from-[#52FAF0] via-[#36BAE0] to-[#197AD0] bg-origin-border"
      style={{
        backgroundImage: 'linear-gradient(#000101, #000101), linear-gradient(180deg, #52FAF0 1.84%, #36BAE0 21.65%, #197AD0 106.4%)',
        backgroundClip: 'padding-box, border-box',
        backgroundOrigin: 'border-box',
        boxShadow: "0px 11px 117.9px 0px #0000008C"
      }}
    >
      <img src={language === "en" ? gb : de} alt="language flag" className=" w-6 h-[15px] sm:w-[27px] sm:h-[18px] md:w-[32px] md:h-[23px] rounded-[5px]" />
    </button>
  );
};

export default LanguageToggle;